import useForgotPassword from './jdm/useForgotPassword';
import useVerifyCode from './jdm/useVerifyCode';
import useResetPassword from './jdm/useResetPassword';
import { useCallback } from 'react';

const useJdmPasswordReset = () => {
    const {
        forgotPassword: triggerForgot,
        isLoading: loadingForgot,
        hasCompleted: forgotCompleted,
        reset: resetForgot,
    } = useForgotPassword();

    const {
        verifyContactCode,
        isLoading: loadingVerify,
        alerts: verifyAlerts,
        hasVerified,
        isSyncedWithFf,
        usernameMatchesFF,
        reset: resetVerify,
    } = useVerifyCode();

    const {
        resetPassword,
        isLoading: loadingReset,
        isSuccess: resetSuccess,
        alerts: resetAlerts,
        reset: resetReset,
    } = useResetPassword();

    const isLoading = loadingForgot || loadingVerify || loadingReset;

    const forgotPassword = useCallback(
        (email: string) => {
            resetVerify();
            resetReset();
            triggerForgot(email);
        },
        [resetVerify, resetReset, triggerForgot]
    );

    const resetAll = useCallback(() => {
        resetForgot();
        resetVerify();
        resetReset();
    }, [resetForgot, resetVerify, resetReset]);

    return {
        forgotPassword,
        verifyContactCode,
        resetPassword,
        isLoading,
        isSuccess: resetSuccess,
        alerts: [...resetAlerts, ...verifyAlerts],
        hasTriggeredForgotPasswordFlow: forgotCompleted,
        hasVerified,
        isSyncedWithFf,
        usernameMatchesFF,
        reset: resetAll,
    };
};

export default useJdmPasswordReset;
